import {
  LineChart as ReLineChart,
  Line,
  XAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import formatNumber from "../../../helpers/formatNumber";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className="bg-dark text-white p-2 rounded shadow-sm border border-secondary">
      <strong>{label}</strong>

      {payload.map((entry, index) => (
        <div key={index} style={{ color: entry.stroke }}>
          {entry.name}: {formatNumber(entry.value) ?? "–"} €
        </div>
      ))}
    </div>
  );
};

export default function LineChart({
  labels,
  datasets,
  datasetLabels = [],
  colors = [],
  tooltip,
  className,
  showLegend = false,
}) {
  const currentYear = new Date().getFullYear();
  const lastYear = (currentYear - 1).toString();

  const data = labels.map((month, i) => {
    const obj = { month };
    datasets.forEach((dataset, idx) => {
      const key = datasetLabels[idx] || `Serie${idx + 1}`;
      obj[key] = dataset[i];
    });
    return obj;
  });

  return (
    <div className={`stock-chart-container ${className}`}>
      <ResponsiveContainer width={"100%"} height="100%">
        <ReLineChart
          data={data}
          margin={{ top: 20, right: 20, left: 20, bottom: 10 }}
        >
          <XAxis dataKey="month" />
          <Tooltip content={tooltip ?? <CustomTooltip />} />
          {showLegend && <Legend />}
          {datasetLabels.map((label, idx) => (
            <Line
              key={label}
              type="monotone"
              dataKey={label}
              stroke={colors[idx % colors.length]}
              strokeWidth={label === lastYear ? 1 : 3}
              dot={{ r: 0.1 }}
              strokeDasharray={label === lastYear ? "2 2" : "0"}
            />
          ))}
        </ReLineChart>
      </ResponsiveContainer>
    </div>
  );
}
